// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__HTxl_","existsNavbar":"Page_existsNavbar__60bFP","darkTheme":"Page_darkTheme__i7_Rp"};